<div id="theodoreIntiaro">
  <div class="tf_container">
    <div class="contentBox">
      <div class="undertitle">
        <div class="titleBox">
          <ng-container>
            <img src="https://theodorealexander.com/images/fd_logo.png" alt="Brand_logo">
          </ng-container>
          <ng-container *ngIf="typeOfFurniture">
            <div class="categoryName">{{typeOfFurniture}}</div>
          </ng-container>
        </div>
        <div class="back">
          <ng-container *ngIf="showPricing">
            <div *ngIf="showPrice | async" class="showPrice">Price: ${{price}}</div>
          </ng-container>
          <a routerLink="{{preUrl}}">
            BACK </a>
        </div>
      </div>
      <hr class="line navBorder topMenu">
      <app-navbar class="topNavbar"></app-navbar>
      <hr class="line navBorder">
      <div class="configuratorOrSummary">
        <app-intiaro-configurator [nextBottomPage]="nextBottomPage" [productId]="productId"
          [customerName]="customerName" [typeOfFurniture]="typeOfFurniture" [showPricing]="showPricing">
        </app-intiaro-configurator>
        <app-summary *ngIf="showSummary" class="summary" [productId]="productId"
          [showPricing]="showPricing"></app-summary>
        <!-- <ng-container *ngIf="showPricing">
          <div *ngIf="showPrice | async" class="price">Price: ${{price}}</div>
        </ng-container> -->
      </div>
    </div>
  </div>
</div>